module.exports = __webpack_public_path__ + "fonts/icomoon.457ac7d.woff";